<template>
  <page :load="doInitNonTrade">
    <v-container fluid grid-list-md>
      <v-layout row wrap align-end>
        <v-flex xs7 md9 lg10>
          <card-menu :items="cardMenu" @cardReturn="visibleControl" subMenu></card-menu>
        </v-flex>
      </v-layout>
      <message :messages="messages"></message>
      <v-layout row wrap>
        <v-flex xs12>
          <form data-vv-scope="nonTradeFilterForm">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn class="mx-2" fab dark small color="teal" v-on="on" @click.native.stop="showFilterList = true">
                          <v-icon dark>mdi-format-list-bulleted</v-icon>
                        </v-btn>
                      </template>
                      <span>Show Saved Filters</span>
                    </v-tooltip>
                    Filters for Non-Trade
                    <span class="caption grey--text font-weight-light">
                      {{ defaultFilter.filterName !== undefined ? ' (' + defaultFilter.filterName + ')' : '' }}</span
                    >
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex xs6 sm4 md3 class="lg4-custom">
                            <v-autocomplete
                              :items="branches"
                              v-model="nonTradeFilterForm.branch"
                              :label="nonTradeFilterLabel.branch"
                              item-text="label"
                              item-value="value"
                              data-vv-name="nonTradeFilterForm.branch"
                              :data-vv-as="nonTradeFilterLabel.branch"
                              :error-messages="errors.collect('nonTradeFilterForm.branch')"
                              clearable
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs6 sm4 md3 class="lg4-custom">
                            <v-text-field
                              v-model="nonTradeFilterForm.fund"
                              :label="nonTradeFilterLabel.fund"
                              :error-messages="errors.collect('nonTradeFilterForm.fund')"
                              data-vv-name="nonTradeFilterForm.fund"
                              :data-vv-as="nonTradeFilterLabel.fund"
                              append-icon="mdi-magnify"
                              @click:append="getHelpList('fund')"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md3 class="lg4-custom">
                            <v-text-field
                              v-model="nonTradeFilterForm.suffix"
                              :label="nonTradeFilterLabel.suffix"
                              :error-messages="errors.collect('nonTradeFilterForm.suffix')"
                              data-vv-name="nonTradeFilterForm.suffix"
                              :data-vv-as="nonTradeFilterLabel.suffix"
                              append-icon="mdi-magnify"
                              @click:append="getHelpList('suffix')"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md3 class="lg4-custom">
                            <v-text-field
                              v-model="nonTradeFilterForm.currency"
                              :label="nonTradeFilterLabel.currency"
                              :error-messages="errors.collect('nonTradeFilterForm.currency')"
                              data-vv-name="nonTradeFilterForm.currency"
                              :data-vv-as="nonTradeFilterLabel.currency"
                              append-icon="mdi-magnify"
                              @click:append="getHelpList('currency')"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md6 class="lg4-custom">
                            <v-text-field
                              v-model="nonTradeFilterForm.addressedTo"
                              :label="nonTradeFilterLabel.addressedTo"
                              :error-messages="errors.collect('nonTradeFilterForm.addressedTo')"
                              data-vv-name="nonTradeFilterForm.addressedTo"
                              :data-vv-as="nonTradeFilterLabel.addressedTo"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md6 class="lg4-custom">
                            <v-text-field
                              v-model="nonTradeFilterForm.netAmt"
                              :label="nonTradeFilterLabel.netAmt"
                              :error-messages="errors.collect('nonTradeFilterForm.netAmt')"
                              data-vv-name="nonTradeFilterForm.netAmt"
                              :data-vv-as="nonTradeFilterLabel.netAmt"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md6 class="lg4-custom">
                            <v-autocomplete
                              :items="tranTypes"
                              v-model="nonTradeFilterForm.tranType"
                              :label="nonTradeFilterLabel.tranType"
                              item-text="label"
                              item-value="value"
                              data-vv-name="nonTradeFilterForm.tranType"
                              :data-vv-as="nonTradeFilterLabel.tranType"
                              :error-messages="errors.collect('nonTradeFilterForm.tranType')"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs6 sm4 md6 class="lg4-custom">
                            <v-text-field
                              v-model="nonTradeFilterForm.documentNo"
                              :label="nonTradeFilterLabel.documentNo"
                              :error-messages="errors.collect('nonTradeFilterForm.documentNo')"
                              data-vv-name="nonTradeFilterForm.documentNo"
                              :data-vv-as="nonTradeFilterLabel.documentNo"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md6 class="lg4-custom">
                            <cal-picker
                              v-model="nonTradeFilterForm.tranDate"
                              :label="nonTradeFilterLabel.tranDate"
                              :data-vv-as="nonTradeFilterLabel.tranDate"
                              data-vv-name="tranDate"
                            ></cal-picker>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-layout row wrap>
                      <v-spacer></v-spacer>
                      <v-card-actions>
                        <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text @click.native="saveFilter = true">Save Current Filters</v-btn>
                        <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-layout>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-flex class="text-right">
              <v-btn color="primary" @click.native="doCreateNonTrade">
                <span>{{ lblCreateNonTrade }}</span>
                <v-icon right dark>mdi-plus</v-icon>
              </v-btn>
              <v-btn class="ml-2" v-if="checkAccess([permissionKeys.perm_041260])" color="info" @click.native="doExportFilters">
                <span>{{ lblExportList }}</span>
                <v-icon right dark>mdi-file-excel</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-data-table
                  v-bind:headers="listNonTradeHeaders"
                  v-bind:items="itemsNonTrade"
                  :server-items-length="totalItemsNonTrade"
                  :footer-props="{ 'items-per-page-options': itemsPerPage }"
                  v-bind:options.sync="paginationNonTrade"
                  item-key="key"
                  :loading="loading"
                  :no-data-text="noDataText"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td v-for="column in selectedNonTradeColumns" :key="column">{{ row.item[column] }}</td>
                      <td class="table-action-header">
                        <table-action
                          :rowData="row"
                          :query="checkAccess([permissionKeys.perm_041230])"
                          @query="doQuery(row.item) && checkAccess([permissionKeys.perm_041230])"
                          :review="doShowReviewAction(row.item) && checkAccess([permissionKeys.perm_041225])"
                          @review="doReview(row) && checkAccess([permissionKeys.perm_041225])"
                          :remove="canRemove(row.item) && checkAccess([permissionKeys.perm_041220])"
                          @remove="doRemoveAccount(row.item) && checkAccess([permissionKeys.perm_041220])"
                        ></table-action>
                      </td></tr
                  ></template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="HelpList" width="900px" persistent>
      <help-list :apiURI="apiURI" :mode="mode" :param="param" :boolRefresh="HelpList" @close="doClose" @doAssign="doAssign($event)"></help-list>
    </v-dialog>
    <confirm v-model="promptRemoveAccount" @ok="deleteAccount"> {{ promptWarnMsg }} - {{ acctNoToRemove }}? </confirm>

    <confirm v-model="promptRemoveAccount2" @ok="deleteAccount">
      {{ promptWarnMsg2 }}
    </confirm>
    <v-dialog v-model="promptCannotRemoveAccount" width="50%" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Warning
          <v-spacer></v-spacer>
          <v-btn text icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12>
                {{ promptWarnMsg }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showFilterList" width="800px" persistent>
      <SearchFilter
        :boolRefresh="showFilterList"
        :filterTitle="'Saved Filters - Non-Trade Listing'"
        @close="showFilterList = false"
        :filterCode="filterCode"
        @applyDefaultFilter="applyDefaultFilter"
      ></SearchFilter>
    </v-dialog>
    <v-dialog v-model="saveFilter" width="800px" persistent>
      <UpdateSearchFilter
        :boolRefresh="saveFilter"
        :dialogTitle="'Filter'"
        :actionName="'new'"
        :filters="nonTradeFilterForm"
        @close="saveFilter = false"
        @reloadList="reloadList"
        :filterCode="filterCode"
        @applyDefaultFilter="applyDefaultFilter"
      ></UpdateSearchFilter>
    </v-dialog>

    <warning v-model="exportList.promptFilterWarning" :label="exportList.promptFilterWarningMsg" @ok="doExportList()"/>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import { mapGetters } from 'vuex'
import { nonTradeViewMixin } from '@/mixins/accounting/nonTrade/nonTradeViewMixin'
import { nonTradeAjaxMixin } from '@/mixins/accounting/nonTrade/nonTradeAjaxMixin'
import { NON_TRADE_LOAD_DATA, ACCOUNTS_LOAD_DATA } from '@/store/types'
import HelpList from '@/components/core/common/dialog/HelpList'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import SearchFilter from '@/components/core/common/dialog/SearchFilter'
import UpdateSearchFilter from '@/components/core/common/dialog/UpdateSearchFilter'
import { expandURI } from '@/utils/ajax'
import { recordLockMixin } from '@/mixins/common/recordLockMixin'
import { permissionKeys } from '@/mixins/global/permissionKey'

export default {
  data() {
    return {
      permissionKeys: permissionKeys,
      lblCreateNonTrade: 'New Non-Trade',
      lblExportList: 'Export List',
      cardMenu: [
        { text: 'Accounts', icon: 'mdi-file-document-box', name: 'accounts', params: { tab: 'accounts' }, access: '', default: false },
        { text: 'Receipt', icon: 'mdi-receipt', name: 'receipts', params: { tab: 'receipt' }, access: '', default: false },
        { text: 'Payment', icon: 'mdi-cash', name: 'payment', params: { tab: 'payment' }, access: '', default: false },
        { text: 'Credit Note', icon: 'mdi-credit-card', name: 'creditNote', params: { tab: 'creditNote' }, access: '', default: false },
        { text: 'Debit Note', icon: 'mdi-credit-card-multiple', name: 'debitNote', params: { tab: 'debitNote' }, access: '', default: false },
        { text: 'Non-Trade', icon: 'mdi-credit-card-multiple', name: 'nonTrade', params: { tab: 'nonTrade' }, access: '', default: true }
      ],
      selectedNonTradeColumns: ['branch', 'type', 'documentNo', 'addrTo', 'fund', 'suffix', 'tranDate', 'curr', 'netAmt', 'local'],
      nonTradeColumns: [
        { text: 'Branch', value: 'branch' },
        { text: 'Type', value: 'type' },
        { text: 'Doc No.', value: 'documentNo' },
        { text: 'Addressed To', value: 'addrTo' },
        { text: 'Fund', value: 'fund' },
        { text: 'Suffix', value: 'suffix' },
        { text: 'Tran Date', value: 'tranDate' },
        { text: 'Curr', value: 'curr' },
        { text: 'Net Amount', value: 'netAmt' },
        { text: 'Local', value: 'local' }
      ],
      paginationNonTrade: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      itemsNonTrade: [],
      selectedPage: 0,
      totalItemsNonTrade: 0,
      nonTradeData: {
        tranMode: '',
        branch: '',
        accountNo: '',
        type: '',
        documentNo: '',
        fund: '',
        suffix: ''
      },
      mode: '',
      HelpList: false,
      param: '',
      apiURI: '',
      delAccountForm: {
        branch: '',
        documentNo: '',
        accountNo: '',
        accountNoSuffix: '',
        fund: '',
        transactionType: '',
        actionName: ''
      },
      warnMsg: '',
      warnMsg2: '',
      promptWarnMsg: '',
      promptWarnMsg2: '',
      delAcct: false,
      matchBatchProcess: null,
      matchCreatedProgId: null,
      glTranFound: null,
      glTranBchNo: null,
      promptCannotRemoveAccount: false,
      promptRemoveAccount: false,
      promptRemoveAccount2: false,
      acctNoToRemove: null,
      filterCode: 'NT',
      newFilter: false,
      saveFilter: false,
      showFilterList: false,
      defaultFilter: {},
      exportList: {
        promptFilterWarning: false,
        promptFilterWarningMsg: 'Do you want to proceed without any filtering?'
      },
      firstTimeCalling: true
    }
  },
  computed: {
    ...mapGetters(['checkAccess']),
    initNonTrade() {
      return this.$store.state.nonTrade.init
    },
    listNonTradeHeaders() {
      let result = []
      for (const selectedNonTradeColumn of this.selectedNonTradeColumns) {
        let findCol = this.nonTradeColumns.find(a => selectedNonTradeColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  methods: {
    visibleControl(data) {
      if (typeof data !== 'undefined') {
        this.visibleTab = { ...data }
      } else {
        this.visibleTab = {}
      }
    },
    async doInitNonTrade() {
      await Promise.all([this.$store.dispatch('nonTradeInit')])
      await Promise.all([this.$store.dispatch('searchFilterInit')])
      this.getDefaultFilter()
      if (this.$store.state.accounts.init === 0) {
        await Promise.all([this.$store.dispatch('accountsInit')])
      }
      if (this.$store.state.commons.init === 0) {
        await Promise.all([this.$store.dispatch('commonsInit')])
      }
      sessionStorage.removeItem('matchList')
      this.$store.commit(NON_TRADE_LOAD_DATA, this.nonTradeData)
      this.cardMenu = []
      if (this.checkAccess([permissionKeys.perm_041005]) === true) {
        this.cardMenu.push({
          text: 'Accounts',
          icon: 'mdi-file-document-box',
          name: 'accounts',
          params: { tab: 'accounts' },
          access: '',
          default: false
        })
      }
      if (this.checkAccess([permissionKeys.perm_041015]) === true) {
        this.cardMenu.push({ text: 'Receipt', icon: 'mdi-receipt', name: 'receipts', params: { tab: 'receipt' }, access: '', default: false })
      }
      if (this.checkAccess([permissionKeys.perm_041050]) === true) {
        this.cardMenu.push({ text: 'Payment', icon: 'mdi-cash', name: 'payment', params: { tab: 'payment' }, access: '', default: false })
      }
      if (this.checkAccess([permissionKeys.perm_041085]) === true) {
        this.cardMenu.push({
          text: 'Credit Note',
          icon: 'mdi-credit-card',
          name: 'creditNote',
          params: { tab: 'creditnote' },
          access: '',
          default: false
        })
      }
      if (this.checkAccess([permissionKeys.perm_041115]) === true) {
        this.cardMenu.push({
          text: 'Debit Note',
          icon: 'mdi-credit-card-multiple',
          name: 'debitNote',
          params: { tab: 'debitnote' },
          access: '',
          default: false
        })
      }
      if (this.checkAccess([permissionKeys.perm_041215]) === true) {
        this.cardMenu.push({
          text: 'Non-Trade',
          icon: 'mdi-credit-card-multiple',
          name: 'nonTrade',
          params: { tab: 'nontrade' },
          access: '',
          default: true
        })
      }
      this.fetchBranchWBranchUserId()
    },
    doClearFilters() {
      var thisPage = this
      this.defaultFilter = {}
      Object.keys(this.nonTradeFilterForm).forEach(function(key, index) {
        thisPage.nonTradeFilterForm[key] = ''
      })
      this.performNonTradeSearch()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('nonTradeFilterForm').then(result => {
        if (result) {
          this.pagination.page = 1
          this.performNonTradeSearch()
        }
      })
    },
    doCreateNonTrade() {
      this.$router.push({ name: 'createNonTrade' }).catch(() => {})
    },
    doQuery(data) {
      if (data) {
        const convert = {
          branch: data.branch,
          acctNo: data.acctNo,
          type: data.type,
          docNo: data.documentNo,
          fund: data.fund,
          suffix: data.suffix
        }
        this.$store.commit(ACCOUNTS_LOAD_DATA, convert)
        this.$router
          .push({ name: 'accountsDetails', params: { accountData: convert, queryAcctMaster: true, fromAcctMaster: true, voidMultiAcct: false } })
          .catch(() => {})
      }
    },
    doShowReviewAction(data) {
      if (data.postNow === 'N') {
        return true
      }
    },
    doReview(data) {
      // AR: OS-660 Added to check if record is locked 2021-01-29
      let recKey =
        data.item.type + '|' + data.item.branch + '|' + data.item.acctNo + '|' + data.item.documentNo + '|' + data.item.fund + '|' + data.item.suffix
      this.checkRecordLock(recKey, 'ACT').then(result => {
        // Record not locked proceed to review 2021-01-29
        if (!result) {
          this.performReview(data)
          // Record was locked show message 2021-01-29
        } else {
          this.loading = false
        }
      })
    },
    performReview(data) {
      if (data.item) {
        data.item.tranMode = 'R'
        this.$store.commit(NON_TRADE_LOAD_DATA, data.item)
        this.$router.push({ name: 'createNonTrade' }).catch(() => {})
      }
    },
    doRemoveAccount(account) {
      this.delAccountForm.branch = account.branch
      this.delAccountForm.documentNo = account.documentNo
      this.delAccountForm.accountNo = account.acctNo
      this.delAccountForm.accountNoSuffix = account.suffix
      this.delAccountForm.fund = account.fund
      this.delAccountForm.transactionType = account.type
      this.delAccountForm.actionName = 'DELETE_ACCOUNT'
      this.acctNoToRemove = account.branch + '-' + account.documentNo
      this.delAcct = true
      this.promptWarnMsg = 'Are you sure you want to delete the selected account'

      if (account.postNow === 'Y') {
        this.doChkBatch(account).then(resultx => {
          this.doChkGLTran(account).then(resultz => {
            if (account.netAmt !== account.osBalance || account.zeroBal === true) {
              // Net Amount != OS Balance
              this.promptWarnMsg = 'Transaction has been matched - Cannot delete'
              this.delAcct = false
            } else if (this.matchBatchProcess === true) {
              // If found in acctMchDet
              this.promptWarnMsg = 'Transaction processed by batch program ' + this.matchCreatedProgId
              this.delAcct = false
            } else if (account.bankTranDate !== null && account.bankTranDate !== '') {
              // If Bank Transaction Date is not blank
              this.promptWarnMsg = 'Transaction has been reconciled with bank Statements - Cannot delete'
              this.delAcct = false
            } else if (this.glTranFound === true) {
              // If found the first child in GLTran
              if (this.glTranBchNo > 0) {
                // If glTRanBchNo != 0
                this.promptWarnMsg = 'Transaction has been posted to GL - cannot delete - Must VOID transaction'
                this.delAcct = false
              }
            } else if (this.glTranFound === false) {
              // Not found record in GLTran
              this.promptWarnMsg = 'This transaction is corrupted - please contact your system administrator'
              this.delAcct = false
            }

            if (this.delAcct) {
              if (
                account.chequePrtd === true ||
                account.bankListPrtd === 'Yes' ||
                account.bankPayInPrtd === 'Yes' ||
                account.docPrtd === 'Yes' ||
                account.brnDocListPrtd === 'Yes'
              ) {
                this.promptWarnMsg = 'Transaction has been printed document/cheques/reports - still delete'
              }
              if (account.bchMch === true) {
                this.promptWarnMsg2 = 'Transaction is set to be Batch Match'
              }
              this.warnMsg = this.promptWarnMsg
              this.warnMsg2 = this.promptWarnMsg2
              this.deleteAccount()
            } else {
              this.promptCannotRemoveAccount = true
            }
            // If postNow = Yes.
            // TODO delete for acctmaster and gltran record and write into audit file if passed all validation
          })
        })
      } else {
        // TODO delete acctmaster and write it into audit file if postNow = No.
        this.warnMsg = this.promptWarnMsg
        this.deleteAccount()
      }
    },
    deleteAccount() {
      if (this.warnMsg !== '') {
        this.promptRemoveAccount = true
        this.warnMsg = ''
      } else if (this.warnMsg2 !== '') {
        this.promptRemoveAccount2 = true
        this.warnMsg2 = ''
      } else {
        this.fetchDelData(this.delAccountForm)
      }
    },
    closeDialog() {
      this.promptCannotRemoveAccount = false
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      this.param = ''
      if (fieldName === 'branch') {
        this.apiURI = this.$store.state.commons.menu.getBranchList
        this.param = this.nonTradeFilterForm.branch
      } else if (fieldName === 'fund') {
        this.apiURI = this.$store.state.commons.menu.getFundList
        this.param = this.nonTradeFilterForm.fund
      } else if (fieldName === 'suffix') {
        this.apiURI = this.$store.state.commons.menu.getSuffixList
        this.param = this.nonTradeFilterForm.suffix
      } else if (fieldName === 'currency') {
        this.apiURI = this.$store.state.commons.menu.getCurrencyList
        this.param = this.nonTradeFilterForm.currency
      }
      this.HelpList = true
    },
    doClose() {
      this.HelpList = false
    },
    doAssign(Obj) {
      switch (this.mode) {
        case 'branch':
          this.nonTradeFilterForm.branch = ''
          this.nonTradeFilterForm.branch = Obj.finalSelectedItems.toString()
          break
        case 'fund':
          this.nonTradeFilterForm.fund = ''
          this.nonTradeFilterForm.fund = Obj.finalSelectedItems.toString()
          break
        case 'suffix':
          this.nonTradeFilterForm.suffix = ''
          this.nonTradeFilterForm.suffix = Obj.finalSelectedItems.toString()
          break
        case 'currency':
          this.nonTradeFilterForm.currency = ''
          this.nonTradeFilterForm.currency = Obj.finalSelectedItems.toString()
          break
      }
    },
    reloadList(filterName) {
      this.defaultFilter.filterName = filterName
      this.saveFilter = false
      this.performNonTradeSearch()
    },
    applyDefaultFilter(filterData) {
      this.defaultFilter = filterData
      if (this.defaultFilter.filters !== undefined) {
        this.nonTradeFilterForm = this.defaultFilter.filters
      }
      this.showFilterList = false
      this.performNonTradeSearch(false)
    },
    async getDefaultFilter() {
      const apiUrl = this.$store.state.searchFilter.menu.defaultFilter
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            filterCode: this.filterCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          this.initialLoad = false
          if (data) {
            this.defaultFilter.filterName = data.defaultFilter.filterName
            this.defaultFilter.filterDesc = data.defaultFilter.filterDesc
            this.defaultFilter.filterCode = data.defaultFilter.filterCode
            this.defaultFilter.filters = JSON.parse(data.defaultFilter.filterContent)
            if (this.defaultFilter.filters !== undefined) {
              this.nonTradeFilterForm = this.defaultFilter.filters
            }
          }
          this.firstTimeCalling = false
          this.performNonTradeSearch(false)
        } catch (err) {
          this.loading = false
        }
      }
    },
    canRemove(data) {
      if (data.postNow === 'N' && data.void_ === false) {
        return true
      }
      return false
    }
  },
  watch: {
    paginationNonTrade: function(value) {
      if (this.firstTimeCalling === false) {
        this.performNonTradeSearch(false)
      }
    }
  },
  mounted() {
    // AR: OS-660 Added to check record lock 2021-01-21
    this.initCommonUtilMenu()
  },
  mixins: [routeMixin, MessageMixin, TableConst.default, nonTradeViewMixin, nonTradeAjaxMixin, commonAjaxMixin, recordLockMixin],
  components: {
    HelpList,
    SearchFilter,
    UpdateSearchFilter
  }
}
</script>
<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
